import {
    GET_ALL_VOUCHER,
    CREATE_NEW_VOUCHER,
    UPDATE_SPECIFIC_VOUCHER,
    GET_SPECIFIC_VOUCHER,
    REMOVE_VOUCHER,
    GET_ALL_VOUCHER_WITH_CONCATENATE,
    GET_ALL_VOUCHER_BY_ACTIVE
} from '../actions/types';

const INIT_STATE = {
    voucher_list: [],
    current_voucher: {},
    voucher_active_list: [],
    active_pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    },
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

const getPagination = payload => ({
    currentPage: parseInt(payload?.current_page || 1, 10),
    total: parseInt(payload?.total || 0, 10),
    perPage: parseInt(payload?.per_page || 30, 10)
});

const dedupeById = items => items.filter((item, index, list) => (
    list.findIndex(other => other.id === item.id) === index
));

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_VOUCHER:
            return {
                ...state,
                voucher_list: action.payload?.data || [],
                pagination: getPagination(action.payload)
            };
        case GET_ALL_VOUCHER_BY_ACTIVE: {
            const receivedItems = action.payload?.data || [];
            const voucherActiveList = action.concatenate
                ? dedupeById([...state.voucher_active_list, ...receivedItems])
                : receivedItems;
            return {
                ...state,
                voucher_active_list: voucherActiveList,
                active_pagination: getPagination(action.payload)
            };
        }
        case GET_ALL_VOUCHER_WITH_CONCATENATE:
            return {
                ...state,
                voucher_list: dedupeById([...state.voucher_list, ...(action.payload?.data || [])]),
                pagination: getPagination(action.payload)
            };
        case CREATE_NEW_VOUCHER:
            return {
                ...state,
                voucher_list: [action.payload, ...state.voucher_list],
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total + 1
                }
            };
        case GET_SPECIFIC_VOUCHER:
            return { ...state, current_voucher: action.payload };
        case UPDATE_SPECIFIC_VOUCHER:
            return {
                ...state,
                voucher_list: state.voucher_list.map(item => (
                    item.id === action.payload.id ? action.payload : item
                ))
            };
        case REMOVE_VOUCHER:
            return {
                ...state,
                voucher_list: state.voucher_list.filter(item => !action.payload.includes(item.id)),
                pagination: {
                    ...state.pagination,
                    total: Math.max(0, state.pagination.total - action.payload.length)
                }
            };
        default:
            return state;
    }
};
